
//production
var admin = "https://8cxk8nt5g4.execute-api.ap-south-1.amazonaws.com/dev/api/";     //admin

var rider = "https://77rmhgxew9.execute-api.ap-south-1.amazonaws.com/dev/api/";     //rider    
var service = "https://iev1ltgkqg.execute-api.ap-south-1.amazonaws.com/dev/api/";     //service





var driver = "https://b8x89ujjg3.execute-api.ap-south-1.amazonaws.com/dev/api/";     //driver

var master = "https://c83kz102ok.execute-api.ap-south-1.amazonaws.com/dev/api/";

//development
var local = "http://localhost:3000/dev/api/";

// import Vue from 'vue'
//var querystring = require('querystring');
import axios, { Axios } from 'axios'
// import store from '../store'

import { authHeader } from '../helpers/auth-header';

let header = authHeader()
// var header={
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": localStorage.getItem("token")
// }};
export default {
    getLan(data) {
        
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getLanguage", JSON.stringify(data), header)
    },

    login(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/userlogin", JSON.stringify(data), header)
    },
    vehiclelist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/adminVehicleList", JSON.stringify(data), header)
    },


    uploadFile(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data), header)
    },

    sosAlertMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/adminuserNotification", JSON.stringify(data), header)
    },
    todaysTravelListDashboard(data) {//Data/subjectlist
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "userRide/todaysTravelListDashboard", JSON.stringify(data), header)
    },
    adminUserProfile(data) {//Data/subjectlist
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/adminUserProfile", JSON.stringify(data), header)
    },
    vehicleDriverList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/vehicleDriverList", JSON.stringify(data), header)
    },
    searchDriverVehicleAdd(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/searchDriverVehicleAdd", JSON.stringify(data), header)
    },
    searchGroupVehicleAdd(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/searchGroupVehicleAdd", JSON.stringify(data), header)
    },
    addDriverVehicle(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/addDriverVehicle", JSON.stringify(data), header)
    },
    activateVehicleDriver(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "userRide/activateVehicleDriver", JSON.stringify(data), header)
    },
    rideMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/userRideMaster", JSON.stringify(data), header)
    },
    deleteusermaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteUser", JSON.stringify(data), header)
    },
    adminsendpushnotification(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/adminsendpushnotification", JSON.stringify(data), header)
    },
    superset_login() {
       
        return axios.post('http://3.110.177.178:8088/api/v1/security/login', JSON.stringify({
            "password": "admin",
            "provider": "db",
            "refresh": true,
            "username": "admin"
        }), header)
    },
    superset_api(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getsupersettoken", JSON.stringify(data), header);

    },
    group_list(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/groupList", JSON.stringify(data), header);
    },
    delete_group_master(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deletegroupmaster", JSON.stringify(data), header)
    },
    geocodelats(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/geocodelats", JSON.stringify(data), header);
    },
    geocodelocationdetails(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/geocodelocationdetails", JSON.stringify(data), header);
    },
    addgroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addgroup", JSON.stringify(data), header)
    },
    editgroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/edit_group", JSON.stringify(data), header)
    },
    groupUserListget(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/groupUserList", JSON.stringify(data), header)
    },
    groupVehicleListget(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/groupVehicleList", JSON.stringify(data), header)
    },
    addUsersToGroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/addUsersToGroup", JSON.stringify(data), header)
    },
    mappedVehcielGroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/mappedVehcielGroup", JSON.stringify(data), header)
    },
    unmappedVehcielGroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/unmappedVehcielGroup", JSON.stringify(data), header)
    },
    add_group_stops(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/add_group_stops", JSON.stringify(data), header)
    },
    delete_group_stops(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/delete_group_stops", JSON.stringify(data), header)
    },
    getMenuList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getMenuList", JSON.stringify(data), header)
    },
    getRoleList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getRoleList", JSON.stringify(data), header)
    },
    addrole(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addrole", JSON.stringify(data), header)
    },
    editrole(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/editrole", JSON.stringify(data), header)
    },
    deleterolemaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleterole", JSON.stringify(data), header)
    },
    getMenuListMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getMenuListMaster", JSON.stringify(data), header)
    },
    addmenu(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addmenu", JSON.stringify(data), header)
    },
    editmenu(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/editmenu", JSON.stringify(data), header)
    },
    deletemenumaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deletemenu", JSON.stringify(data), header)
    },
    saveRoleMenuMapping(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/saveRoleMenuMapping", JSON.stringify(data), header)
    },
    user_rolelist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/user_rolelist", JSON.stringify(data), header)
    },
    addclient(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addclient", JSON.stringify(data), header)
    },
    editclient(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/editclient", JSON.stringify(data), header)
    },
    edituser(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/edituser", JSON.stringify(data), header)
    },
    regUser(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/regUser", JSON.stringify(data), header)
    },
    clientdepartmentlist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "clientdepartment/clientdepartmentlist", JSON.stringify(data), header)
    },
    clientDepartmentAdd(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "clientdepartment/clientDepartmentAdd", JSON.stringify(data), header)

    },
    clientDepartmentUpdate(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "clientdepartment/clientDepartmentUpdate", JSON.stringify(data), header)

    },
    client_DepartmentDelete(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "clientdepartment/clientDepartmentDelete", JSON.stringify(data), header)

    },
    groupList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/groupList", JSON.stringify(data), header)

    },
    clientDepartmentMappGroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "clientdepartment/clientDepartmentMappGroup", JSON.stringify(data), header)

    },
    getclientist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getclientist", JSON.stringify(data), header)
    },
    department_grouplist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/department_group_list", JSON.stringify(data), header)
    },

    editvehicle(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/vehicleEdit", JSON.stringify(data), header)
    },
    upload_to_AWS(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data), header);
    },
    vehicle_type_master(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/get_vehicle_type_master", JSON.stringify(data), header)
    },
    vehicle_list_by_client_id(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/vehicle_list_by_client_id", JSON.stringify(data), header)
    },
    searchhireVehicleAdd(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/searchhireVehicleAdd", JSON.stringify(data), header)
    },


    uploadFile(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data), header)
    },

    HireVehicleList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/HireVehicleList", JSON.stringify(data), header)
    },

    vehicles_group_list(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/vehicles_group_list", JSON.stringify(data), header)
    },

    unmap_vehicle_route(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/unmap_vehicle_route", JSON.stringify(data), header)
    },
    get_client_type_master(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/get_client_type_master", JSON.stringify(data), header)
    },
    clientDashboard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/clientDashboardData", JSON.stringify(data), header)
    },
    fmDashboardData(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/fmDashboardData", JSON.stringify(data), header)
    },
    ServiceList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/UserServiceList", JSON.stringify(data), header)
    },
    serviceRequestList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/serviceRequestList", JSON.stringify(data), header)
    },
    deleteservicedata(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/deleteservice", JSON.stringify(data), header)
    },
    UserServicereqList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/UserServicerequestList", JSON.stringify(data), header)
    },
    get_RideData(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getRideDataLive", JSON.stringify(data), header)
    },
    bulkvehicleupload_save(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/bulkvehicleupload", JSON.stringify(data), header)
    },
    bulkuserupload_save(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/bulkuserupload", JSON.stringify(data), header)
    },
    deletevehicle(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/vehicleDelete", JSON.stringify(data), header)
    },
    RoleGroupMasterList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/RoleGroupMasterList", JSON.stringify(data), header)
    },

    departmentVehicleListget(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/departmentVehicleList", JSON.stringify(data), header)
    },
    mappedVehcielDepartment(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "vehicles/mappedVehcielDepartment", JSON.stringify(data), header)
    },

    //******************************************************************E ticket************************************************************ */
    TicketTypeMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketTypeMaster", JSON.stringify(data), header)
    },
    TicketCategoryMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketCategoryMaster", JSON.stringify(data), header)
    },
    TicketStatusMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketStatusMaster", JSON.stringify(data), header)
    },
    submit_TicketNewUser(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/submitTicketNewUser", JSON.stringify(data), header)
    },
    reg_user(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/regCustomerUser", JSON.stringify(data), header)
    },
    upload_to_AWS(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "getSignedUrlsgb/getSignedURL", JSON.stringify(data), header);
    },
    ticketlist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/ticketlist", JSON.stringify(data), header)   //admin
    },

    dashboardticketlist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/dashboardticketlist", JSON.stringify(data), header)   //admin
    },
    submitTicket(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/submitTicket", JSON.stringify(data), header)
    },
    userlist(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/userList", JSON.stringify(data), header)
    },
    customerDashboardData(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/customerDashboardData", JSON.stringify(data), header)
    },
    agentDashboardData(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/agentDashboardData", JSON.stringify(data), header)
    },
    AdminDashboardData(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/adminDashboardData", JSON.stringify(data), header)
    },
    ticketByCategoriesDashboard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/ticketByCategoriesDashboard", JSON.stringify(data), header)
    },
    passwordreset(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/resetPassword", JSON.stringify(data), header)
    },
    updateUserProfile(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/updateUserProfile", JSON.stringify(data), header)
    },
    updateUserStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/updateUserStatus", JSON.stringify(data), header)
    },
    updateTicketStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/updateTicketStatus", JSON.stringify(data), header)
    },
     async getticketDetails(data) {
        data.client_id = localStorage.getItem('client_id');
        return  await axios.post(admin + "user/ticketDetails", JSON.stringify(data), header) //admin
    },
    EditTicket(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/editTicket", JSON.stringify(data), header)
    },
    SendTicketComment(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/postTicketComment", JSON.stringify(data), header)
    },
    assignAgent(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/assignAgent", JSON.stringify(data), header)
    },
    agentListDropdown(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/agentListDropdown", JSON.stringify(data), header)
    },
    adminAgentListMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/adminAgentListMaster", JSON.stringify(data), header)
    },
    categoryListmaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/categoryListmaster", JSON.stringify(data), header)    //admin
    },
    categoryAddEdit(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/categoryAddEdit", JSON.stringify(data), header)   ///admin
    },
    ticketByAgentAdminDashboard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/ticketByAgentAdminDashboard", JSON.stringify(data), header)
    },
    ticketByDateDashboard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/ticketByDateDashboard", JSON.stringify(data), header)
    },
    deleteCategory(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteCategory", JSON.stringify(data), header)
    },
    deleteTicket(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteTicket", JSON.stringify(data), header)
    },
    customerList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/customerList", JSON.stringify(data), header)
    },
    getFaqMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getFaqMaster", JSON.stringify(data), header)
    },
    addEditFaq(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addEditFaq", JSON.stringify(data), header)
    },
    deleteFaqMaster(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteFaqMaster", JSON.stringify(data), header)
    },
    getClientList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getClientList", JSON.stringify(data), header)
    },
    updateClientProfile(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/updateClientProfile", JSON.stringify(data), header)
    },
    addclient(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/addclient", JSON.stringify(data), header)
    },
    deleteclient(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteclient", JSON.stringify(data), header)
    },
    userNotification(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/userNotification", JSON.stringify(data), header)
    },
    read_notification(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/read_notification", JSON.stringify(data), header)
    },
    getTicketSource(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketSource", JSON.stringify(data), header)
    },

    //source master
    getSourceList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/getSourceList", JSON.stringify(data), header)
    },
    updateSourceProfile(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/updateSourceProfile", JSON.stringify(data), header)
    },
    addSource(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/addSource", JSON.stringify(data), header)
    },
    deleteSource(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/deleteSource", JSON.stringify(data), header)
    },

    // type master
    getTicketTypeList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketType/getTicketTypeList", JSON.stringify(data), header)
    },
    addTicketType(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketType/addTicketType", JSON.stringify(data), header)
    },
    updateTicketType(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketType/updateTicketType", JSON.stringify(data), header)
    },
    deleteTicketType(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketType/deleteTicketType", JSON.stringify(data), header)
    },

    // Status master
    getTicketStatusList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketStatus/getTicketStatusList", JSON.stringify(data), header)
    },
    addTicketStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketStatus/addTicketStatus", JSON.stringify(data), header)
    },
    updateStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketStatus/updateStatus", JSON.stringify(data), header)
    },
    deleteTicketStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "TicketStatus/deleteTicketStatus", JSON.stringify(data), header)
    },
    deleteTicketComment(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deletecomment", JSON.stringify(data), header)
    },
    ticketByWardAdminDashboard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/ticketByWardAdminDashboard", JSON.stringify(data), header)   //admin
    },
    getPriorityList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/getPriorityList", JSON.stringify(data), header)   //master
    },
    getPriorityList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/getPriorityList", JSON.stringify(data), header)   //master
    },
    getWardList(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/getWardList", JSON.stringify(data), header)   //master
    },
    wardlist(data) {
      
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/wardlist", JSON.stringify(data), header)   //admin
    },
    updatepriority(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/updatepriority", JSON.stringify(data), header)
    },
    deleteWard(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/deleteWard", JSON.stringify(data), header)
    },
    updateward(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/updateward", JSON.stringify(data), header)
    },
    updatepriority(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master + "source/updatepriority", JSON.stringify(data), header)
    },
    sendotp(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/sendotp", JSON.stringify(data), header)
    },
    verifyOtp(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/verifyOtp", JSON.stringify(data), header)
    },
    resetnewPassword(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/resetnewPassword", JSON.stringify(data), header)
    },
    getTicketRoleStatusMapping(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketRoleStatusMapping", JSON.stringify(data), header)
    },
    getTicketRejectionReason(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getTicketRejectionReason", JSON.stringify(data), header)
    },
    getAllDesignation(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getAllDesignation", JSON.stringify(data), header)
    },
    getAllEmploymentStatus(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getAllEmploymentStatus", JSON.stringify(data), header)
    },
    getAllTicketStatusGroup(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/getAllTicketStatusGroup", JSON.stringify(data), header)
    },
    wardAddEdit(data) {
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin + "user/wardAddEdit", JSON.stringify(data), header)
    },
    getLanguage(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/getLanguage", JSON.stringify(data),  header) 
    },
    bill_list(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/billlist", JSON.stringify(data),  header) 
    },
    billAddEdit(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/billAddEdit", JSON.stringify(data),  header) 
    },
    deleteBill(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/deleteBill", JSON.stringify(data),  header) 
    },
    getBillTypeMaster(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/getBillTypeMaster", JSON.stringify(data),  header) 
    },
    getStatusBillMaster(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/getStatusBillMaster", JSON.stringify(data),  header) 
    },

    //assets
     getAllAssetMaster(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/getAllAssetMaster", JSON.stringify(data),  header) 
    },
    listAssets(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/listAssets", JSON.stringify(data),  header) 
    },
    createAsset(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/createAsset", JSON.stringify(data),  header) 
    },
    updateAsset(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/updateAsset", JSON.stringify(data),  header) 
    },
    insertTransaction(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/insertTransaction", JSON.stringify(data),  header) 
    },
    listTransaction(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/listTransaction", JSON.stringify(data),  header) 
    },

    listAssetTypes(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/listAssetTypes", JSON.stringify(data),  header) 
    },
    createAssetType(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/createAssetType", JSON.stringify(data),  header) 
    },
    updateAssetType(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/updateAssetType", JSON.stringify(data),  header) 
    },

    listAssetSubtypes(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/listAssetSubtypes", JSON.stringify(data),  header) 
    },
    createAssetSubtype(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/createAssetSubtype", JSON.stringify(data),  header) 
    },
    updateAssetSubtype(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/updateAssetSubtype", JSON.stringify(data),  header) 
    },


    Depreciation_Schedule_Report_Asset_Wise(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/Depreciation_Schedule_Report_Asset_Wise", JSON.stringify(data),  header) 
    },
    get_asset_register_report(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/get_asset_register_report", JSON.stringify(data),  header) 
    },
    get_depreciation_schedule_report(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/get_depreciation_schedule_report", JSON.stringify(data),  header) 
    },
    get_asset_disposal_report(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/get_asset_disposal_report", JSON.stringify(data),  header) 
    },
    calculateYearlyDepreciation(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/calculateYearlyDepreciation", JSON.stringify(data),  header) 
    },
    createauditentry(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"asset/createAuditEntry", JSON.stringify(data),  header) 
    },
    //Feddback
    listFeedback(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"feedback/listFeedback", JSON.stringify(data),  header) 
    },
    //Scheme
    createScheme(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"phc/createScheme", JSON.stringify(data),  header) 
    },
    updateScheme(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"phc/updateScheme", JSON.stringify(data),  header) 
    },
    deleteScheme(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"phc/deleteScheme", JSON.stringify(data),  header) 
    },
    listScheme(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"phc/listScheme", JSON.stringify(data),  header) 
    },

    //job opening
    ListJobOpenings(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/ListJobOpenings", JSON.stringify(data),  header) 
    },
    createJobOpenings(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/createJob", JSON.stringify(data),  header) 
    },
    updateJobOpenings(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/updateJob", JSON.stringify(data),  header) 
    },

    //job application
    ListJobApplications(data){
        //data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/ListJobApplications", JSON.stringify(data),  header) 
    },


    //worker profiles
    WorkerProfileList(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/WorkerProfileList", JSON.stringify(data),  header) 
    },

    //Attendance
    GetAttendance(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/GetAttendance", JSON.stringify(data),  header) 
    },

    //worker profiles
    createAboutus(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/createAboutus", JSON.stringify(data),  header) 
    },
    updateAboutus(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/updateAboutus", JSON.stringify(data),  header) 
    },
    deleteAboutus(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(master+"source/deleteAboutus", JSON.stringify(data),  header) 
    },
    ListAboutUs(data){
        data.client_id = localStorage.getItem('client_id');
        return axios.post(admin+"user/ListAboutUs", JSON.stringify(data),  header) 
    },
}